import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { EditorRestrictionModalProps } from './EditorRestrictionModal';

export const openEditorRestrictionModal = ({ onClose, ...data }: EditorRestrictionModalProps) =>
    openPopupHelper({ popupName: popupNames.EDITOR_RESTRICTION_MODAL, data, onClose });
